import { Button, Dialog, styled, TextField } from '@cherre-frontend/ui';

export const HeaderContainer = styled('div')`
  display: flex;
  justify-content: space-between;
`;

export const Title = styled('h5')`
  font-family: Montserrat;
  font-weight: 700;
  font-size: 20px;
  line-height: 24.5px;
  letter-spacing: 1%;
  margin: 0px;
`;

export const Description = styled('p')`
  font-family: Montserrat;
  font-weight: 500;
  font-size: 14px;
  line-height: 17.5px;
  letter-spacing: 1%;
  margin: 0px;
  margin-bottom: 20px;
  margin-top: 8px;
`;

export const FieldsContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const Subtitle = styled('h6')`
  font-family: Montserrat;
  font-weight: 700;
  font-size: 14px;
  line-height: 17.5px;
  letter-spacing: 1%;
  margin: 0px;
  margin-bottom: 8px;
`;

export const ButtonsContainer = styled('div')`
  display: flex;
  justify-content: end;
  gap: 8px;
  margin-top: 20px;
`;

export const StyledDialog = styled(Dialog)`
  & > div {
    & > div {
      padding: 20px;
      width: 579px;
      max-width: unset;
      border-radius: 10px;
    }
  }
`;

export const StyledCloseButton = styled(Button)`
  padding: 0px;
  min-width: unset;
  &:hover {
    background-color: transparent;
  }
`;

export const InputsContainer = styled('div')`
  display: flex;
  gap: 40px;
`;

export const StyledTextField = styled(TextField)`
  & > div {
    border-radius: 6px;
    border-color: #9e9e9e;
    min-height: 33px;
    & > label {
      top: -10px;
    }
  }
  background: ${({ theme }) => theme.palette.grey[50]};
  input {
    border-radius: 6px;
  }
`;

export const InputLabel = styled('label')`
  color: #000000;
  font-family: Montserrat;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
`;

export const InputDescription = styled('p')`
  color: #212121;
  font-family: Montserrat;
  font-weight: 500;
  font-size: 14px;
  line-height: 17.5px;
  letter-spacing: 1%;
  margin: 0px;
  margin-top: 4px;
  margin-bottom: 8px;
`;

export const PreviewContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const PreviewContent = styled('p')`
  margin: 0px;
  margin-top: 4px;
  color: #212121;
  font-family: Montserrat;
  font-weight: 500;
  font-size: 14px;
  line-height: 17.5px;
  letter-spacing: 1%;
`;
